// Function to transform API response to the desired format
const transformAllHotelData = (response) => {
    const results = response.results[0];

    // Extracting relevant data
    const transformedData = results.data.map((hotel) => ({
        id: hotel?.id || '',
        hotelName: hotel?.name || '',
        hotelId: hotel?.id || '',
        img: hotel?.heroImage || '',
        starRating: hotel?.starRating || '',
        reviews: hotel?.reviews[0] || {},
        rates: hotel?.availability?.rate,
        isRefundable: hotel?.availability?.options?.refundable,
        isBreakfastAvailable: hotel?.availability?.options?.freeBreakfast,
        starRate: hotel?.starRating,
        badgesData: hotel?.badges || [],
        tagsData: hotel?.tags || [],
        contractedProvider: hotel?.availability?.contractedProvider || false
    }));

    return {
        traceId: results.traceId,
        currentPage: results.currentPage,
        totalPages: results.totalPages,
        currencyCode: results.currencyCode,
        propertyAvailableTypes: results.availableTypes,
        userReviewRating: results.facets.reviewRatings,
        propertyAvailableFacilities: results.availableFacilities,
        popularFilters: results.tags,
        hotels: transformedData,
        nextPage: results.nextPage || null
    };
};

export default transformAllHotelData;
